import { Pagination, Skeleton, Space, Table, TableColumnsType, Tooltip, Typography } from "antd";
import { DataTable, SkeletonChart, WrapperCard } from "@components/index";
import styles from "./Widgets.module.scss";
import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useMaskId } from "~/Hooks/useMaskId";
import moment from "moment";
import { getColoriezedValue } from "~/Utils/getColorizedValue";
import { useAuth } from "@hooks/useAuth";
import { defaultCurrencyCode, formatToDecimal, UserType } from "~/Utils";
import { useHasAccess } from "@hooks/useHasAccess";
import { get as _get } from "lodash";
import { getFormattedDate, scrollToElement } from "~/Utils/CommonUtils";
import { useQuery } from "~/Hooks/useQuery";

interface Props {
  data: any;
  isLoading: boolean;
  moduleName: any;
  url: any;
  totalPage: any;
  onPageChange: any;
  currentPage: any;
  pageSize: any;
  isMobile:boolean;
}

export const LatestContracts = ({
  data,
  isLoading,
  moduleName,
  url,
  totalPage,
  onPageChange,
  currentPage,
  pageSize,
  isMobile,
}: Props) => {
  const navigate = useNavigate();
  const { mask } = useMaskId();
  const { user } = useAuth();
  const { hasRole } = useHasAccess();
  const [filteredData, setFilteredData] = useState<any>({});
  const query = useQuery();
  useEffect(() => {
    if (data) {
      setFilteredData(data?.records);
    } else {
      setFilteredData(null);
    }
  }, [data]);

  if (query.get("onboardedListPage")) {
    setTimeout(() => {
      scrollToElement("onBoardList");
    }, 1000);
  }

  const columnsSPA: TableColumnsType = [
    {
      title: "Project ID",
      dataIndex: "projectId",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      // sorter: (a: any, b: any) => (a.contractName || "").localeCompare(b.contractName || ""),
    },
    {
      title: "Project Name",
      dataIndex: "projectTitle",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      // sorter: (a: any, b: any) => (a.contractName || "").localeCompare(b.contractName || ""),
    },
    {
      title: "Budget",
      dataIndex: "budget",
      render: (value: any) => value || <Typography.Text >Uncategorized</Typography.Text>,
    },
    {
      title: "SPA Types",
      dataIndex: "awardAndStrategyPaper",
      render: (value: any) => value || <Typography.Text >Uncategorized</Typography.Text>,
    },
    {
      title: "Created At",
      dataIndex: "createdOn",
      render: (value: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: false,
      sorter: false,
      width: 120,
      // sorter: (a: any, b: any) => Number(new Date(a.createdOn)) - Number(new Date(b.createdOn)),
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      // sorter: (a: any, b: any) => (a.contractName || "").localeCompare(b.contractName || ""),
    },
    {
      title: "Owner Email",
      dataIndex: "ownerEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      // sorter: (a: any, b: any) => (a.contractName || "").localeCompare(b.contractName || ""),
    },
    {
      title: "Proposed Contract Value",
      dataIndex: "contractValue",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Budget/PTE",
      dataIndex: "amount",
      render: (value: any, record: any) => value && formatToDecimal(value, record?.currencyCode || defaultCurrencyCode),
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      // sorter: (a: any, b: any) => (a.contractName || "").localeCompare(b.contractName || ""),
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      // sorter: (a: any, b: any) => (a.contractName || "").localeCompare(b.contractName || ""),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (value: any) => getColoriezedValue(value),
      // sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
    },
    {
      title: "Completed At",
      dataIndex: "completedDate",
      width: 120,
      render: (value: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: false,
      sorter: false,
    },
  ];

  return (
    <WrapperCard
      isMobile={isMobile}
      title={<Link to={url}>{moduleName}</Link>}
      // action={<Link to="/clm/contracts">View All</Link>}
      {...(isLoading && { bodyClass: styles.ActiveLoadingCard })}
    >
      {isLoading ? (
        <SkeletonChart
          chartType="table"
          chartHeight={300}
        />
      ) : (
        data && (
          <div>
            <DataTable
              className="table-clickable"
              multiSelect={false}
              size="middle"
              showTopBar={false}
              height={data && data.records && data.records.length * 120}
              onClick={(record) => {
                navigate(`/dashboard?onboardedListPage=${currentPage}`);
                navigate(`/spa/view/${record.envelopeId}`);
              }}
              tableData={
                filteredData && filteredData
                  ? filteredData.map((item: any, index: number) => {
                      return {
                        ...item,
                        key: item.envelopeId,
                        createdon: item.createdon && moment(item.createdon).format("YYYY-MM-DD"),
                        projectId: item.projectId,
                      };
                    })
                  : null
              }
              columns={columnsSPA}
            />
            <div
              id="onBoardList"
              className="pagination"
            >
              <Pagination
                defaultCurrent={1}
                showSizeChanger={false}
                current={currentPage + 1}
                onChange={(page) => onPageChange(page)}
                total={totalPage}
                pageSize={pageSize}
              />
            </div>
          </div>
        )
      )}
    </WrapperCard>
  );
};
